import React from 'react';
import { Play, Trees } from 'lucide-react';

const CustomerDemoSection: React.FC = () => {
  return (
    <section className="bg-paper py-24 lg:py-32 relative overflow-hidden">
      <div className="max-w-editorial mx-auto px-6 lg:px-10 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 lg:gap-16 items-center">

          {/* Video — vertical, centered */}
          <div className="md:col-span-5 md:col-start-1 flex justify-center md:justify-start">
            <div className="relative w-full max-w-sm">
              <div className="aspect-[9/16] bg-forge-deep overflow-hidden border border-ink-200 shadow-lg">
                {/* ref force-sets the muted ATTRIBUTE (React only sets the property,
                    which some browsers' autoplay policies ignore) and nudges playback */}
                <video
                  ref={(el) => {
                    if (!el) return;
                    el.muted = true;
                    el.setAttribute('muted', '');
                    el.play().catch(() => {/* autoplay blocked — poster stays visible */});
                  }}
                  className="w-full h-full object-cover"
                  src="/videos/customer-demo.mp4"
                  poster="/videos/customer-demo-poster.jpg"
                  autoPlay
                  loop
                  muted
                  playsInline
                  aria-label="Customer demonstrating an Incolma machete clearing saplings in the woods."
                />
              </div>
              {/* Play indicator */}
              <div className="absolute top-4 left-4 flex items-center gap-2 bg-forge-deep/80 backdrop-blur-sm px-3 py-1.5 rounded-full">
                <Play className="w-3 h-3 text-paper-warm fill-paper-warm" strokeWidth={1.5} />
                <span className="font-mono text-[10px] tracking-micro uppercase text-paper-warm">
                  Customer footage
                </span>
              </div>
            </div>
          </div>

          {/* Copy */}
          <div className="md:col-span-6 md:col-start-7">
            <p className="font-mono text-[11px] tracking-micro uppercase text-ember mb-6">
              — In the field
            </p>
            <h2 className="font-editorial italic font-light text-4xl lg:text-5xl text-ink-950 mb-8 leading-[1.05] tracking-tight">
              Built for the<br/>
              <span className="text-ember">real work.</span>
            </h2>

            <div className="space-y-5 max-w-prose">
              <p className="text-ink-700 text-lg leading-[1.65]">
                Real customers. Real conditions. No studio lighting, no choreography —
                just an Incolma blade doing what it was forged to do.
              </p>
              <p className="text-ink-700 text-lg leading-[1.65]">
                Drop-forged carbon steel. Full tang. Cast handle.
                The kind of blade your grandfather would still trust to clear the back forty.
              </p>
            </div>

            <div className="mt-10 flex items-center gap-3 border-t border-ink-200 pt-8">
              <Trees className="w-4 h-4 text-ember" strokeWidth={1.5} />
              <span className="font-mono text-[11px] tracking-micro uppercase text-ink-500">
                Real-world sapling clearing — fall 2024
              </span>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default CustomerDemoSection;
